import { MenuItem, OutlinedInput, Select, Tooltip } from "@material-ui/core";
import { useState, forwardRef } from "react";
import { iconInfor } from "assets/icons";
import useStyles from "./styles";
import { arrowDownIcon, iconGrayArrowDown } from "assets/icons";

interface ObjectDropdown {
  display: string;
  value: any;
}

interface CustomDropDownProps {
  data: ObjectDropdown[];
  label?: string;
  onChangeCategory: (event: any) => void;
  value: string;
  placeholder?: string;
  customClass?: string;
  tooltipComponent?: NonNullable<React.ReactNode>;
  name?: string;
  errors?: boolean;
  disable?: boolean;
  itemType?: any;
}

const CustomDropDown = forwardRef((props: CustomDropDownProps, ref: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const styles = useStyles();
  const {
    data,
    label,
    placeholder,
    onChangeCategory,
    value,
    customClass,
    tooltipComponent,
    name,
    errors,
    disable,
    itemType,
  } = props;

  const onOpenDropDown = () => {
    if (itemType === "rest") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  const onCloseDropDown = () => {
    setIsOpen(false);
  };

  return (
    <div
     data-cy="cypress-my-category-dropdown"
      className={`${customClass} ${errors && styles.containerErr} ${
        disable && styles.disable
      }`}
    >
      <div className={styles.rowLabel}>
        <label className={styles.label}>{label}</label>
        {tooltipComponent ? (
          <Tooltip
            placement="top"
            title={tooltipComponent}
            classes={{
              tooltip: styles.tooltip,
              arrow: styles.popupTooltip,
            }}
          >
            <img src={iconInfor} />
          </Tooltip>
        ) : null}
      </div>

      <div className={itemType?.type === 'rest' ? styles.container2 : styles.container}>
        <Select
          disabled={disable}
          name={name}
          // @ts-ignore
          onOpen={onOpenDropDown}
          onClose={onCloseDropDown}
          displayEmpty
          value={value}
          onChange={onChangeCategory}
          renderValue={(selected: any) => {
            if (selected?.length === 0) {
              return (
                <label className={styles.placeholder}>
                  {placeholder || ""}
                </label>
              );
            }
            return (
              <label className={itemType?.type === 'rest' ? styles.menuItem2 : styles.menuItem}>
                {data.find((item) => item.value == selected)?.display}
              </label>
            );
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            getContentAnchorEl: null,
            classes: {
              paper: styles.paper,
            },
          }}
          inputProps={{ "aria-label": "Without label" }}
          input={<OutlinedInput ref={ref} />}
          classes={{
            root: styles.rootDropdown,
          }}
          IconComponent={() => {
            return null;
          }}
        >
     
          {itemType?.type === "rest" ? (
            <MenuItem
              value={itemType?.value}
              className={styles.menuItem}
              key={itemType?.value}
            >
              {itemType?.display}
            </MenuItem>
          ) : (
            data?.map((item) => (
              <MenuItem
                value={item?.value}
                className={styles.menuItem}
                key={item?.value}
              >
                {item?.display}
              </MenuItem>
            ))
          )}
        </Select>
        {itemType?.type !== "rest" && (
          <img
            src={disable ? iconGrayArrowDown : arrowDownIcon}
            className={`${styles.iconDropdown} ${
              isOpen ? styles.iconUp : styles.iconDown
            }`}
            alt="icon"
          />
        )}
      </div>
    </div>
  );
});

export default CustomDropDown;
